import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TitleAndDescription from 'app/scripts/components/common/title-and-description';
import { ExportApiKeySettings } from 'app/scripts/components/preferences/general/export-api-key/ExportApiKeySettings';
import { getAccessTokens } from 'app/scripts/components/preferences/general/generalSettingsActions';

const EXPORT = 'export';
const SSO = 'sso';
const MODERATION = 'moderation';

class AccessTokens extends Component {
  UNSAFE_componentWillMount() {
    const { spotId, getAccessTokens } = this.props;
    getAccessTokens(spotId);
  }

  getAccessTokens() {
    var components = null;
    var { accessTokens, spotId } = this.props;
    const data = accessTokens[spotId];

    if (data) {
      var types = Object.keys(data);
      components = types.map((type, i) => {
        var component = null;

        if (data[type].enabled) {
          component = this.getTokenComponent(data, type, i);
        }
        return component;
      });
    }
    return components;
  }

  getTokenComponent(obj, type, index) {
    var title;
    switch (type) {
      case EXPORT:
        title = 'Export v2 API key';
        break;
      case SSO:
        title = 'SSO';
        break;
      case MODERATION:
        title = 'Moderation';
        break;
      default:
        title = type;
    }

    return (
      <div className="description" key={index}>
        {title}: {obj[type].accessToken}
      </div>
    );
  }

  render() {
    var component = null;
    var accessTokensComponent = this.getAccessTokens();

    if (accessTokensComponent) {
      component = (
        <div className="access-tokens">
          <TitleAndDescription title="Authentication Tokens" />
          <ExportApiKeySettings />
          {accessTokensComponent}
        </div>
      );
    }

    return component;
  }
}

AccessTokens.displayName = 'AccessTokens';

AccessTokens.propTypes = {
  spotId: PropTypes.string.isRequired,
  isAdmin: PropTypes.bool,
  accessTokens: PropTypes.object,
  getAccessTokens: PropTypes.func
};

function mapStateToProps(state) {
  return {
    accessTokens: state.settings.general.accessTokens
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAccessTokens: spotId => dispatch(getAccessTokens(spotId))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AccessTokens);
